import type { DocSchema } from './schema';

/** 고용노동부 폭염 대응 단계 — 체감온도 31℃ 관심 · 33℃ 주의 · 35℃ 경고 · 38℃ 위험. */
export const HEAT_STAGES = ['관심', '주의', '경고', '위험'];

/** 온열질환 증상 구분. */
const HEAT_SYMPTOMS = ['열사병', '열탈진', '열경련', '열실신', '열발진'];

/** 일일 점검의 의무조치 — 고용노동부 「온열질환 예방 가이드」 의 물 · 그늘 · 휴식과 단계별 조치. */
const HEAT_MEASURES = [
  '시원하고 깨끗한 물 제공',
  '그늘 · 휴게시설 설치(작업장 가까이)',
  '휴식시간 부여(주의 · 경고 시간당 10분, 위험 15분)',
  '14~17시 옥외작업 단축 · 중지(경고 · 위험)',
  '근로자 건강상태 확인',
  '보냉장구(쿨토시 · 아이스조끼 등) 지급',
  '온열질환 예방교육 · 증상 시 조치 안내',
  '민감군(고령 · 기저질환 · 신규 배치) 관리',
  '응급조치 체계 · 비상연락망 확인',
];

/** 양식 문서 칸 정의 — 온열질환(DOC-136). */
export const HEAT_DOCS: Record<'HEAT_CHECK' | 'HEAT_ACCIDENT', DocSchema> = {
  HEAT_CHECK: {
    code: 'HEAT_CHECK',
    titleKey: 'stage',
    sections: [
      {
        kind: 'fields',
        label: '점검 개요',
        fields: [
          { key: 'checkDate', label: '점검일자', kind: 'date' },
          { key: 'checkTime', label: '점검시각', kind: 'time' },
          { key: 'inspector', label: '점검자' },
          { key: 'temperature', label: '기온(℃)', kind: 'number' },
          { key: 'humidity', label: '상대습도(%)', kind: 'number' },
          { key: 'feelsLike', label: '체감온도(℃)', kind: 'number' },
          { key: 'stage', label: '단계', kind: 'select', options: HEAT_STAGES },
        ],
      },
      {
        kind: 'table',
        key: 'measures',
        label: '의무조치 이행',
        columns: [
          { key: 'measure', label: '조치' },
          { key: 'done', label: '이행', kind: 'check', width: '64px' },
          { key: 'note', label: '비고', width: '30%' },
        ],
        initialRows: HEAT_MEASURES.map((measure) => ({ measure, done: '', note: '' })),
      },
      {
        kind: 'table',
        key: 'zones',
        label: '구역별 측정',
        columns: [
          { key: 'zone', label: '구역', width: '22%' },
          { key: 'temperature', label: '기온(℃)', kind: 'number', width: '12%' },
          { key: 'humidity', label: '습도(%)', kind: 'number', width: '12%' },
          { key: 'feelsLike', label: '체감온도(℃)', kind: 'number', width: '14%' },
          { key: 'action', label: '조치' },
        ],
      },
      {
        kind: 'fields',
        fields: [{ key: 'note', label: '특이사항', kind: 'textarea', wide: true, rows: 3 }],
      },
    ],
  },
  HEAT_ACCIDENT: {
    code: 'HEAT_ACCIDENT',
    titleKey: 'place',
    sections: [
      {
        kind: 'fields',
        label: '발생 개요',
        fields: [
          { key: 'occurredDate', label: '발생일자', kind: 'date' },
          { key: 'occurredTime', label: '발생시각', kind: 'time' },
          { key: 'place', label: '장소' },
          { key: 'zone', label: '구역' },
          { key: 'temperature', label: '당시 기온(℃)', kind: 'number' },
          { key: 'humidity', label: '당시 습도(%)', kind: 'number' },
          { key: 'feelsLike', label: '당시 체감온도(℃)', kind: 'number' },
        ],
      },
      {
        kind: 'table',
        key: 'victims',
        label: '재해자',
        columns: [
          { key: 'name', label: '성명', width: '16%' },
          { key: 'company', label: '소속', width: '20%' },
          { key: 'job', label: '직종', width: '16%' },
          { key: 'age', label: '나이', kind: 'number', width: '10%' },
          { key: 'symptom', label: '증상', kind: 'select', options: HEAT_SYMPTOMS },
        ],
      },
      {
        kind: 'fields',
        label: '경위 및 조치',
        fields: [
          { key: 'circumstance', label: '발생 경위', kind: 'textarea', wide: true, rows: 4 },
          { key: 'firstAid', label: '응급조치', kind: 'textarea', wide: true, rows: 3 },
          { key: 'hospital', label: '병원 이송', wide: true },
        ],
      },
      {
        kind: 'table',
        key: 'prevention',
        label: '재발 방지대책',
        columns: [
          { key: 'measure', label: '대책' },
          { key: 'owner', label: '담당', width: '16%' },
          { key: 'dueDate', label: '완료예정', kind: 'date', width: '18%' },
        ],
      },
    ],
  },
};
